import { IAutocompleteField } from 'types/shared';
import { GetCustomersDTO, KontentLanguageDTO, XTMProjectDTO } from 'utils/restApplicationClient';
import { GetTemplatesDTO } from 'utils/restApplicationClientTypeOverrides';
export class AddContentParser {
  parseLanguages = (languagesList?: Array<KontentLanguageDTO>): Array<IAutocompleteField<KontentLanguageDTO>> => {
    const parsedLanguagesList = languagesList?.map((language) => ({ label: language.name, value: language }));
    return Array.isArray(parsedLanguagesList) ? parsedLanguagesList : [];
  };

  parseCustomers = (customerDTO?: GetCustomersDTO): Array<{ value: string; label: string }> => {
    // @TODO change when BE fixes EP
    const parsedCustomers = this.parseAutocomplete(customerDTO?.customers, 'name', 'xtmCustomerId');
    return Array.isArray(parsedCustomers) ? parsedCustomers : [];
  };

  parseTemplates = (templateDTO?: GetTemplatesDTO): Array<{ value: string; label: string }> => {
    const parsedTemplates = this.parseAutocomplete(templateDTO?.templates, 'name', 'xtmTemplateId');
    return Array.isArray(parsedTemplates) ? parsedTemplates : [];
  };

  parseProjects = (projects?: Array<XTMProjectDTO>): Array<{ value: string; label: string }> => {
    if (projects) {
      const parsedProjects = this.parseAutocomplete(projects, 'name', 'id');
      return Array.isArray(parsedProjects) ? parsedProjects : [];
    }
    return [];
  };

  private parseAutocomplete<T>(
    objectsToParse: Array<T> | undefined,
    labelKey: keyof T,
    valueKey: keyof T,
  ): Array<{ value: string; label: string }> | { value: string; label: string } {
    if (objectsToParse === undefined || objectsToParse === null) {
      return [];
    } else {
      return objectsToParse.map((object) => {
        if (typeof object === 'string') {
          return {
            label: object,
            value: object,
          };
        }
        return {
          label: ((object[labelKey] as unknown) as string).toString(),
          value: ((object[valueKey] as unknown) as string).toString(),
        };
      });
    }
  }
}

export default new AddContentParser();
